import React, { useEffect, useState } from "react";
import { colors } from "utils";
import { Spin } from "antd";
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer } from "recharts";
import { getMonth, getShortMonth } from "utils/dates";

const SmallLine = ({ graph, filters, setSendLPY }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [linesPerYear, setLinesPerYear] = useState([]);

  useEffect(() => {
    if (graph) {
      let tmpLPY = [];
      if (filters.created_year) {
        tmpLPY = tmpLPY.filter((lpy) => filters.created_year.includes(lpy));
      }

      let currentData = Array(12)
        .fill()
        .map((item, idx) => {
          return { ...item, name: idx + 1 };
        });

      const orderedGraph = graph.sort((prevDate, currentDate) => {
        if (prevDate.label && currentDate.label) {
          return new Date(`${prevDate.label}-1`) - new Date(`${currentDate.label}-1`);
        }
        return 1;
      });

      orderedGraph.forEach((graphData, idx) => {
        if (graphData.label) {
          const [year, month] = graphData.label.split("-");
          if (!tmpLPY.includes(year)) tmpLPY.push(year);
          let tmpItem = currentData.find((cd) => cd.name === Number(month));
          tmpItem[year] = graphData.val;
        }
      });

      currentData.map((data, idx) => {
        tmpLPY.forEach((year) => {
          if (!data[year]) {
            data[year] = 0;
          }
          if (idx > 0) {
            data[year] = currentData[idx - 1][year] + data[year];
          }
        });
        return data;
      });
      setLinesPerYear(tmpLPY);
      setData(currentData);
    }
  }, [graph, filters]);

  useEffect(() => {
    if (data.length > 0 && linesPerYear.length > 0) {
      setLoading(false);
    }
    return () => {
      if (data.length === 0 && linesPerYear.length === 0) {
        setLoading(true);
      }
    };
  }, [data, linesPerYear]);

  return (
    <Spin spinning={loading}>
      <ResponsiveContainer height={200}>
        {graph.length > 0 ? (
          <LineChart data={data}>
            <XAxis dataKey="name" tickFormatter={(t) => getShortMonth(Number(t))} />
            <YAxis
              // width={100}
              tickFormatter={(t) => {
                if (t > 1000) {
                  return (t / 1000000).toLocaleString("fr-CA") + " M.";
                } else {
                  return t.toLocaleString("fr-CA");
                }
              }}
            />
            <Tooltip
              labelFormatter={(t) => getMonth(Number(t))}
              formatter={(value, name, props) => value.toLocaleString("fr-CA")}
            />
            {linesPerYear &&
              filters &&
              linesPerYear.map((line, idx) => {
                return (
                  <Line
                    id={line}
                    key={line + idx}
                    type="monotone"
                    dataKey={line}
                    stroke={colors[idx]}
                  />
                );
              })}
            <Legend />
          </LineChart>
        ) : (
          <p className="no-data">Aucune données disponibles pour le moment.</p>
        )}
      </ResponsiveContainer>
    </Spin>
  );
};

export default SmallLine;
